import React from "react"
import DatePicker from "react-datepicker";
import ProductInformationRow from './ProductInformationRow';
import FormConfirm from './FormConfirm';
import { EnamelPaintingWorkOrderTitles } from "../../../constants/work-order-titles";
import { useDispatch, useSelector } from 'react-redux';
import { UtilityFunctions } from "../../../utils";
import CustomInput from '../../../components/atoms/Input';
import { enamelPaintingFormActions } from "../../../store/slices";

function EnamelPainting({ title }) {

    const dispatch = useDispatch();
    const enamelPaintingForm = useSelector(state => state.enamelPaintingForm.enamelPaintingForm);

    const handleDateChange = (date, name) => {
        // set date-related productInformation
        dispatch(
            enamelPaintingFormActions.setEnamelPaintingForm({
                ...enamelPaintingForm,
                'date': date,
            }),
        )
    }

    const handleInput = (e) => {

        const { name, value } = e.target;

        // set product workOrderForm
        dispatch(
            enamelPaintingFormActions.setEnamelPaintingForm({
                ...enamelPaintingForm,
                [name] : parseInt(value)
            }),
        )
    };
    

    const CustomDatePickerInput = React.forwardRef(({ value, onClick }, ref) => (
        <CustomInput
            onClick={onClick}
            ref={ref}
            className={'work-order-form-information-item'}
            id={'enamel-painting-form-date'}
            name={'date'}
            defaultValue={enamelPaintingForm.date}
            workorder
        />
    ));

    return (
        <div className='work-order-form main-container'>
            <div className='form-table'>
            <div className='work-order-form-title'>
                    <h2>{title}</h2>
                    <div className='work-order-information'>
                        <div className="header-item-container">
                            <span className='header'>Takip No:</span>
                            <CustomInput
                                className={'work-order-form-information-item'}
                                id={'enamel-painting-form-id'}
                                name={'enamelPaintingFormId'}
                                label={'Takip No'}
                                defaultValue={enamelPaintingForm.enamelPaintingFormId}
                                onChange={handleInput}
                                workorder
                                type={"number"}
                            />
                        </div>
                        <div className="header-item-container">
                            <span className='header'>Tarih</span>
                            <DatePicker
                                key={'date-picker'}
                                locale={'tr'}
                                onSelect={(date, e) => { handleDateChange(UtilityFunctions.formatDate(date)) }} //when day is clicked
                                customInput={
                                    <CustomDatePickerInput />
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className='work-order-titles'>
                    {EnamelPaintingWorkOrderTitles.map((title, index) => (
                        <div key={index} className='column row-cell'>
                            {title}
                        </div>
                    ))}
                </div>
                <div className='form-row-container'>
                    <ProductInformationRow />
                    {
                        enamelPaintingForm.rows.map((item, index) => {
                            return (
                                <ProductInformationRow readOnly rowData={item} key={index} />
                            )
                        })
                    }
                </div>
                <FormConfirm />
            </div>
        </div>
    );
}
export default EnamelPainting;
